let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("duLwX")).then(() => parcelRequire('b2SjD'));